module.exports = __webpack_public_path__ + "static/media/478.c366b62a.webp";